<template>
<li>
    <a href="/rooms/"><i class="fa fa-building-o"></i> Rooms
        <span class="badge badge-new-bookings" data-toggle="tooltip" data-placement="right" title="Rooms text here">2</span>
    </a>
    <div class="grid-container4">
        <ul>
            <li><a href="/rooms/calendar/"><i class="fa fa-calendar"></i> Buchungskalender</a></li>
            <li><a href="/rooms/bookings/"><i class="fa fa-list"></i> Buchungsliste</a></li>
            <li><a href="/rooms/bookings/status/unconfirmed/"><i class="fa fa-list"></i> Unbestätigte Buchungen</a></li>
        </ul>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
